import EfSpec from '@elem/ui/ef-spec';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import ModuleTabs from '../../components/ModuleTabs';
import css from './index.module.scss';
import { B_DATA } from './common';
import { queryCatagoryTree, queryCatagoryTreeNew } from '@/service';
import { dashName, efFetch, getHostApi, handleMultiProductImages } from '@/utils';

type ListType = {
    key: string;
    productCatagoryId: string;
    text: string;
    arr: any[];
    subs: any[];
    name: string;
};

type ProductType = {
    images: string;
    productCatagoryName: string;
    spuId: string;
    name: string;
};

export default function B() {
    const { locale = 'us' } = useRouter();
    const { moduleTitle, all, less } = (B_DATA[locale] || B_DATA['us']) ?? {};
    const contentRef = useRef<HTMLDivElement>(null);

    const [productSupport, setProductSupport] = useState<ListType[]>([]);
    useEffect(() => {
        getProductSupport(locale).then((res) => {
            const list: ListType[] = [];
            res.forEach((item) => {
                if (item?.subs?.length > 0) {
                    const arr = item.subs.filter((subItem) => subItem.arr.length > 0);
                    item.subs = arr;
                }
                if (item?.subs?.length > 0 || item?.arr?.length > 0) {
                    list.push(item);
                }
            });
            setProductSupport(list);
        });
    }, [locale]);

    const [activeTab, setActiveTab] = useState(0);
    const [activeSubTab, setActiveSubTab] = useState(0);
    // @ts-ignore
    const getTabs = (list: ListType[], attrNamee = 'text') => list.map((item, idx) => ({ ...item, label: item[attrNamee], value: idx }));

    const isSubs = useMemo(() => productSupport[activeTab]?.subs?.length > 0, [productSupport, activeTab]);
    const currentProduct: ProductType[] = useMemo(() => {
        const currentProductSupport = productSupport[activeTab];
        if (currentProductSupport?.arr?.length > 0) {
            return currentProductSupport.arr;
        }
        return currentProductSupport?.subs[activeSubTab]?.arr;
    }, [productSupport, activeTab, activeSubTab]);

    const [showAll, setShowAll] = useState(false);

    if (productSupport.length === 0) return null;
    return (
        <div className={`support-module ${css['Support']}`} ref={contentRef}>
            <EfSpec />
            <div className="support-title">{moduleTitle}</div>
            <ModuleTabs
                list={getTabs(productSupport)}
                value={activeTab}
                contentRef={contentRef}
                onChange={(val) => {
                    setActiveTab(val);
                    setActiveSubTab(0);
                }}
            />
            {isSubs && (
                <ModuleTabs list={getTabs(productSupport[activeTab]?.subs, 'name')} contentRef={contentRef} value={activeSubTab} onChange={setActiveSubTab} />
            )}
            <div className="B-list">
                {currentProduct
                    ?.filter((_, idx) => idx < (!showAll ? 10 : 99999))
                    .map((item, idx) => (
                        <EfLink
                            className="B-list-item"
                            href={`faqs/${dashName(item.name) || dashName(item.productCatagoryName)}/${item.spuId}`}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_support',
                                navigation_name: getTabs(productSupport)[activeTab].text,
                                list_name: isSubs
                                    ? getTabs(productSupport[activeTab]?.subs, 'name')[activeSubTab].name
                                    : getTabs(productSupport)[activeTab].text,
                                product_name: item.name,
                            }}
                            key={idx}
                        >
                            <EfImg className="B-list-img" pc={item.images} />
                            <div className="B-list-title">{item.name}</div>
                        </EfLink>
                    ))}
            </div>
            {currentProduct?.length > 10 && (
                <div className="B-view-all" onClick={() => setShowAll((show) => !show)}>
                    {showAll ? <span>{less}</span> : <span>{all}</span>}
                </div>
            )}
        </div>
    );
}

async function getProductSupport(locale: string) {
    const queryCatagoryTreeData2 = await queryCatagoryTreeNew(locale);
    const queryCatagoryTreeData = queryCatagoryTreeData2?.data?.map?.((i) => {
        const obj = {
            name: i.productCatagoryName,
            productCatagoryId: i.productCatagoryId,
            arr: [],
            subs: [],
        };
        if (i.spuList[0]?.spuList?.length > 0) {
            obj.subs = i.spuList.map((j) => ({
                ...j,
                name: j.productCatagoryName,
            }));
            // 存在副 tab
        } else {
            // 不存在副 tab
            obj.arr = i.spuList;
        }
        return obj;
    });

    const spuListData = await efFetch(`${getHostApi(locale).NEXT_PUBLIC_API_HOST}/spu/cms?sort=name&size=100&locale=${locale}`, {
        cacheTime: 1000 * 10,
    });

    let productList: any[] = [];
    try {
        productList = getProductList(queryCatagoryTreeData || [], spuListData.data || []);
    } catch (error) {}

    return productList;
}

/**
 * 1. 产品透明底 png 图片
 * 2. 产品白底 jpg 图片
 * 3. 产品 nav 图
 * 4. 产品规格图
 */
const getImg = (imgsStr: string) =>
    handleMultiProductImages(imgsStr, 'trans') ||
    handleMultiProductImages(imgsStr) ||
    handleMultiProductImages(imgsStr, 'nav') ||
    handleMultiProductImages(imgsStr, 'specs');

function getProductList(queryCatagoryTreeData: any, spuListData: any) {
    const productList: object[] = [];

    queryCatagoryTreeData?.map((item: any) => {
        item.arr = [];
        if (item?.subs?.length > 0) {
            item?.subs?.forEach((subs: any) => {
                subs.arr = [];
                spuListData?.forEach((list: any) => {
                    if (list.productCatagoryId == subs.productCatagoryId) {
                        list.imagesArr = [];
                        list.titleArr = [];
                        list.colors = 'black';
                        list.images = getImg(list.images);
                        subs.arr.push({ ...list });
                    }
                });
            });
        } else {
            spuListData?.forEach((list: any) => {
                if (list.productCatagoryId == item.productCatagoryId) {
                    list.imagesArr = [];
                    list.titleArr = [];
                    list.colors = 'black';
                    list.images = getImg(list?.images);
                    item.arr.push({ ...list });
                }
            });
        }

        productList.push({
            key: item.productCatagoryId,
            text: item.name,
            arr: item.arr,
            productCatagoryId: item.productCatagoryId,
            ...(item.subs ? { subs: item.subs } : {}),
        });
    });

    return productList;
}
